import { useCallback, useRef } from 'react';

export const OTAProgressPhase = {
    download: 0,
    install: 1,
    afterReboot: 2,
};

export const OTAProgressProgress = {
    started: 0,
    inProgress: 1,
    failed: 2,
    finished: 3,
    rebooting: 4,
};

// both hub-ota and device-ota
export default function useOTAProgress(sendEvent) {
    const otaReportCallbacks = useRef({});
    const registerNotification = useCallback((callbackId, callback) => {
        otaReportCallbacks.current[callbackId] = callback;
    }, []);
    const unregisterNotification = useCallback((callbackId) => {
        if (callbackId in otaReportCallbacks.current)
            delete otaReportCallbacks.current[callbackId];
    }, []);

    const otaReportUniversalCallbacks = useRef({});
    const registerUniversalNotification = useCallback((callbackId, callback) => {
        otaReportUniversalCallbacks.current[callbackId] = callback;
    }, []);
    const unregisterUniversalNotification = useCallback((callbackId) => {
        if (callbackId in otaReportUniversalCallbacks.current)
            delete otaReportUniversalCallbacks.current[callbackId];
    }, []);

    const startHubOTA = useCallback(() => {
        sendEvent('start_hub_ota', {});
    }, [sendEvent]);

    const onOTAProgress = useCallback((message) => {
        const data = message.msg;
        let otaID = undefined;

        if (message.ev === "hub_ota_progress") {
            otaID = "hub";
        } else {
            otaID = message.msg["ota_id"];
        }

        // if (otaReportCallbacks.current.hasOwnProperty(id)) {
        if (Object.prototype.hasOwnProperty.call(otaReportCallbacks.current, otaID)) {
            const callback = otaReportCallbacks.current[otaID];
            callback(data); // { phase, progress, progress_value }
        }
        
        const universalCallbackIDs = Object.keys(otaReportUniversalCallbacks.current);
        for (let i = 0; i < universalCallbackIDs.length; i++) {
            const callbackId = universalCallbackIDs[i];
            const callback = otaReportUniversalCallbacks.current[callbackId];
            callback(otaID, data); // (otaID, { phase, progress, progress_value })
        }
    }, []);

    const otaProgressController = {
        registerNotification, registerUniversalNotification,
        unregisterNotification, unregisterUniversalNotification,
        startHubOTA
    }
    return [onOTAProgress, otaProgressController];
}